module.exports = __webpack_public_path__ + "static/media/live_pp_3xtve.2bccd044.png";